import * as actions from "./actionsType";

const initialData = {
  loaderNineBoxes: false,
  nineBoxes: null,
  potencial_promedio: null,
  desempenio_promedio: null,
  employees: null,
  divisions: null,
  nineBoxesFalla: null,
  saveLoaderNineBoxes: false,
  nineBoxesFormError: null,
};

export default function NineBoxesReducer(state = initialData, action) {
  switch (action.type) {
    case actions.LOADER_NINE_BOXES:
      return { ...state, loaderNineBoxes: action.payload };

    case actions.GET_NINE_BOXES:
      return {
        ...state,
        nineBoxes: action.payload.nineBoxes,
        potencial_promedio: action.payload.potencial_promedio,
        desempenio_promedio: action.payload.desempenio_promedio,
        employees: action.payload.employees,
        divisions: action.payload.divisions,
      };

    case actions.NINE_BOXES_FALLA:
      return { ...state, nineBoxesFalla: action.payload };

    case actions.FORM_NINE_BOXES_FAIL:
      return { ...state, nineBoxesFormError: action.payload };

    default:
      return state;
  }
}
